import { AsyncPipe, CommonModule, NgClass, NgFor, NgIf, SlicePipe } from '@angular/common';
import {
  AfterContentChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewContainerRef,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink, RouterModule } from '@angular/router';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { GlobalMessageService, GlobalMessageType, I18nModule, provideConfig, TranslatePipe, UrlModule, UrlPipe } from '@spartacus/core';
import {
  CurrentProductService,
  ListNavigationModule,
  MediaComponent,
  MediaModule,
  ProductListItemContext,
  ProductListItemContextSource,
  ProductListOutlets,
} from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { CUSTOM_LAUNCH_CALLER, LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { CheckoutConstants } from 'src/app/model/checkout.model';
import { DealerPrice } from 'src/app/model/dealer-price.model';
import { ShimanoProduct } from 'src/app/model/product.model';
import { CheckoutServiceExtends } from 'src/app/service/checkout/checkout.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { DealerPriceService } from 'src/app/service/dealer-price/dealer-price.service';
import {
  GoogleTagManagerEvent,
  GoogleTagManagerService,
} from 'src/app/service/googletagmanager/google-tag-manager.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { PlpPopupService } from 'src/app/service/plp-popup/plp-popup.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { DealerPriceCheckerService } from 'src/app/utility/dealer-price-checker.service';
import { ShimanoUtilMethod } from 'src/app/utility/methods.util';
import { RemoveImageTitleAttrDirective } from '../../../../../shared/remove-title-attr.directive';
import { ErpPromotionalTextComponent } from '../../../promotional-text/erp-promotional-text/erp-promotional-text.component';
import { PromotionalTextComponent } from '../../../promotional-text/promotional-text.component';
import { TooltipTextComponent } from '../../../tooltip-text/tooltip-text.component';

@Component({
  selector: 'app-product-grid-item',
  templateUrl: './product-grid-item.component.html',
  styleUrls: ['./product-grid-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [
    ProductListItemContextSource,
    {
      provide: ProductListItemContext,
      useExisting: ProductListItemContextSource,
    },
    provideConfig({
      ...(LaunchDialogModalLayoutConfig?.PlpGridCart || {}), //TODO: Upgrade
    }),
  ],
  imports: [
    NgIf,
    RouterLink,
    MediaComponent,
    RemoveImageTitleAttrDirective,
    TooltipTextComponent,
    NgFor,
    PromotionalTextComponent,
    ErpPromotionalTextComponent,
    NgClass,
    MatIcon,
    MatTooltip,
    AsyncPipe,
    SlicePipe,
    UrlPipe,
    TranslatePipe,
    CommonModule,
    RouterModule,
    MediaModule,
    ListNavigationModule,
    UrlModule,
    I18nModule,
  ],
})
export class ProductGridItemComponent implements OnInit, OnDestroy, OnChanges, AfterContentChecked {
  readonly ProductListOutlets = ProductListOutlets;
  @Input() product: any;
  @Input() dealerPrices: DealerPrice[];
  @Input() isSearchPage: boolean;
  @Input() position: number;
  @Input() hasDealerPrice: boolean;
  @Input() basepriceHidden: boolean;
  showSrp = false;
  hasDealerPriceSubs = true;
  dealerPriceCheckerSubscription$: Subscription;
  addToCartSubscription$: Subscription;
  srpSubscription$: Subscription;
  productCodesList: string[] = [];
  hasColor: string[] = [];
  cart: any;
  code: any;
  product$: Observable<ShimanoProduct> = this.currentProductService.getProduct() as Observable<ShimanoProduct>;

  activeCountry$: Observable<string> = this.countryService.getActive();

  noPointerEventsOnElement: string;
  showGstExclusive$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.checkoutServiceExtends.isCheckoutFeatureEnabled$(activeCountry, CheckoutConstants.GST_EXCLUSIVE)
    )
  );
  showGstInclusive$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.checkoutServiceExtends.isCheckoutFeatureEnabled$(activeCountry, CheckoutConstants.GST_INCLUSIVE)
    )
  );
  businessType: string;
  closeModalSubscription$: Subscription;
  isPlpPopupEnabled: boolean;
  isDisabled = false;

  constructor(
    protected currentProductService: CurrentProductService,
    protected modalService: StandardModalService,
    protected el: ElementRef,
    protected vcr: ViewContainerRef,
    protected productListItemContextSource: ProductListItemContextSource,
    private cartService: ActiveCartFacade,
    private messageService: GlobalMessageService,
    private componentService: ComponentService,
    private dealerPriceService: DealerPriceService,
    private cdr: ChangeDetectorRef,
    // private store: Store<StateWithCart>,
    private gtmService: GoogleTagManagerService,
    private dealerPriceChecker: DealerPriceCheckerService,
    private countryService: ShimanoCountryService,
    private storageService: StorageService,
    private checkoutServiceExtends?: CheckoutServiceExtends,
    private currentBusinesstype?: CurrentBusinessType,
    private plpPopupService?: PlpPopupService
  ) {
    this.getInitSrpToggleValue();
  }

  // addToCart(code: string) {
  //   this.cartService
  //     .getEntry(code)
  //     .subscribe(() => {
  //       this.cartService.addEntry(code, 1);
  //       // this.cart = this.store.pipe(select(CART_FEATURE));
  //       // const sub = this.cart.subscribe((cart) => {
  //       //   if (!cart.active.loading && !cart.active.error && cart.active.success) {
  //       //     this.showGlobalMessage('cart.addToCartSuccess', GlobalMessageType.MSG_TYPE_CONFIRMATION, this.code);
  //       //     sub.unsubscribe();
  //       //   }
  //       //   if (!cart.active.loading && cart.active.error && !cart.active.success) {
  //       //     sub.unsubscribe();
  //       //   }
  //       // });
  //     })
  //     .unsubscribe();
  // }
  private showGlobalMessage(text: string, param: string, messageType: GlobalMessageType) {
    this.messageService.add({ key: text, params: { productName: param } }, messageType);
    const element: HTMLElement = document.getElementsByClassName('BottomHeaderSlot')[0] as HTMLElement;
    element.scrollIntoView();
  }

  ngOnInit() {
    this.isPlpPopupEnabled = this.componentService.plpPopupEnabled$.getValue();
    this.getInitSrpToggleValue();

    this.srpSubscription$ = this.componentService.srpToggle$.subscribe((checked) => {
      this.showSrp = checked;
      this.cdr.detectChanges();
    });

    this.dealerPriceCheckerSubscription$ = this.componentService.hasDealerPrice$.subscribe((hasDealerPrice) => {
      this.hasDealerPriceSubs = hasDealerPrice;
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });
    setTimeout(() => {
      this.hasDealerPriceSubs = this.hasDealerPrice;
    }, 1000);
    this.businessType = this.currentBusinesstype.getBusinessType();
    this.addToCartSubscription$ = this.componentService.isAddToCartDisabled$.subscribe((data) => {
      this.isDisabled = data;
      this.cdr.detectChanges();
    });
  }

  plpGridModalScroll(productValue: any): void {
    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.PLP_GRID_CART_MODAL, this.el, this.vcr, {
        product: productValue,
        hasShowSrp: this.showSrp,
      })
      ?.pipe(take(1))
      .subscribe(() => {});
  }

  getInitSrpToggleValue() {
    this.showSrp = this.storageService.getLocalStorageItem('showSrp') === 'true';
  }

  dealerPrice(productCode: string): string {
    this.dealerPrices = this.componentService.plpDealerPrices$.getValue();
    if (this.dealerPrices) {
      return this.dealerPriceService.getDealerPriceByProductCode(this.dealerPrices, productCode);
    }
  }

  dealerPriceValue(productCode: string): number {
    if (this.dealerPrices) {
      return this.dealerPriceService.getDealerPriceValueByProductCode(this.dealerPrices, productCode);
    }
  }

  replacement(event: { srcElement: { click: () => void }; stopPropagation: () => void }) {
    event.srcElement.click();
    event.stopPropagation();
    return false;
  }

  getImageRendition(image: any) {
    let size: string;
    size = ShimanoUtilMethod.imageRendition(240);
    return ShimanoUtilMethod.newImageFormat(image, size);
  }

  getColorImageRendition(image: any, code: string) {
    this.hasColor.push(code);
    let size: string;
    size = ShimanoUtilMethod.imageRendition(40);
    return ShimanoUtilMethod.newImageFormat(image, size);
  }

  dealerPriceData(productCode: string): DealerPrice {
    if (this.dealerPrices) {
      return this.dealerPriceService.getDealerPriceData(this.dealerPrices, productCode);
    }
  }

  hasProdColor(code: string) {
    if (this.hasColor.indexOf(code) >= 0) {
      return true;
    } else {
      return false;
    }
  }

  gtmProductClick(product: any, position: number) {
    const gtmTag = {
      event: GoogleTagManagerEvent.PRODUCT_CLICK,
      ecommerce: '',
      content_type: 'product',
      content_id: product.code,
      content_name: product.baseProductName,
    };
    this.gtmService.pushTag({
      ecommerce: null,
      search_term: '',
      results_page: '',
      affiliation: '',
      content_type: '',
      content_id: '',
      content_name: '',
    });
    this.gtmService.pushTag(gtmTag);
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    if (this.srpSubscription$) {
      this.srpSubscription$.unsubscribe();
    }
    if (this.dealerPriceCheckerSubscription$) {
      this.dealerPriceCheckerSubscription$.unsubscribe();
    }
  }

  ngOnChanges(changes?: SimpleChanges): void {
    if (changes?.product) {
      this.productListItemContextSource.product$.next(this.product);
    }
    if (this.closeModalSubscription$) {
      this.closeModalSubscription$.unsubscribe();
    }
    if (this.addToCartSubscription$) {
      this.addToCartSubscription$.unsubscribe();
    }
  }
}
